// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Additional utility classes */
.text-center {
  text-align: center;
}

.w-100 {
  width: 100%;
}

/* Filter row styles */
.filter-row {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.filter-row .mat-mdc-cell {
  padding: 8px 12px;
  border-bottom: none;
}

.filter-row input.form-control-sm {
  width: 100%;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 4px 8px;
  background-color: white;
}

.filter-row input.form-control-sm:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.filter-row input.form-control-sm::placeholder {
  color: #6c757d;
  font-style: italic;
}

/* Table styling improvements */
.turbine-table {
  width: 100%;
}

.turbine-table .mat-mdc-header-row {
  height: 56px;
}

.turbine-table .filter-row {
  height: 48px;
  min-height: 48px;
}

.turbine-table .mat-mdc-row {
  height: 48px;
}

.search-container {
  margin-bottom: 20px;
}

.search-container .search-field {
  width: 100%;
}

.total-count {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
  text-align: right;
}

.button-container{
  display: flex;
}

/* Status filter styles */
.status-filter-container {
  margin-top: 8px;
}

.status-filter-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.checkbox-group {
  display: flex;
  gap: 16px;
  align-items: center;
}

.status-checkbox {
  font-size: 14px;
}

.status-checkbox .mdc-form-field {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .checkbox-group {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  
  .status-filter-container {
    margin-bottom: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/turbines/turbine-list.component.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Additional utility classes */\n.text-center {\n  text-align: center;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n/* Filter row styles */\n.filter-row {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.filter-row .mat-mdc-cell {\n  padding: 8px 12px;\n  border-bottom: none;\n}\n\n.filter-row input.form-control-sm {\n  width: 100%;\n  font-size: 12px;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  padding: 4px 8px;\n  background-color: white;\n}\n\n.filter-row input.form-control-sm:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.filter-row input.form-control-sm::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Table styling improvements */\n.turbine-table {\n  width: 100%;\n}\n\n.turbine-table .mat-mdc-header-row {\n  height: 56px;\n}\n\n.turbine-table .filter-row {\n  height: 48px;\n  min-height: 48px;\n}\n\n.turbine-table .mat-mdc-row {\n  height: 48px;\n}\n\n.search-container {\n  margin-bottom: 20px;\n}\n\n.search-container .search-field {\n  width: 100%;\n}\n\n.total-count {\n  margin-top: 16px;\n  font-size: 14px;\n  color: #666;\n  text-align: right;\n}\n\n.button-container{\n  display: flex;\n}\n\n/* Status filter styles */\n.status-filter-container {\n  margin-top: 8px;\n}\n\n.status-filter-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #333;\n}\n\n.checkbox-group {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.status-checkbox {\n  font-size: 14px;\n}\n\n.status-checkbox .mdc-form-field {\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .checkbox-group {\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n  }\n  \n  .status-filter-container {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
